import { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import CustomTable from "../../components/customTable/CustomTable";
import { createMRTColumnHelper } from "material-react-table";
// import { mmtc_sell_responseApi } from "../../app/slices/mmtc/mmtc_sell_responseSlice";
import DateSearchComponent from "../../components/customTable/DateSearchComponent";

import {
  Box,
  Button,
  CircularProgress,
  Dialog,
  DialogContent,
  DialogTitle,
  Divider,
  Tooltip,
  Typography,
} from "@mui/material";
import { IconButton } from "@mui/material";
import { ContentCopy } from "@mui/icons-material";
import { toast } from "react-toastify";
import { mmtc_redeemApi } from "../../app/slices/mmtc/mmtc_redeemSlice";
import Swal from "sweetalert2";
import axios from "axios";
import CloseIcon from "@mui/icons-material/Close";

import {
  Timeline,
  TimelineItem,
  TimelineSeparator,
  TimelineConnector,
  TimelineContent,
  TimelineOppositeContent,
  TimelineDot,
} from "@mui/lab";

import useFilterHandler from "../../components/filterhandler";
import Loader from "../digitalGold/Loader";
import Filter from "../../components/Filter";
import axiosInstance from "../../utils/axiosInstance";

export default function Mmtc_redeem() {
  const dispatch = useDispatch();
  const [queryParams, setQueryParams] = useState({
    startDate: null,
    endDate: null,
  });

  const [filterData, setFilterData] = useState({
    startDate: "",
    endDate: "",
    metalType: "",

    name: "",
    orderId: "",

    transactionId: "",
    quoteId: "",
    customerRefNo: "",
  });

  const url = `/api/admin/mmtc-redeem/list`;

  const {
    handleFilterSubmit,
    handleClearFilters,
    loader,
    results,
    apiCall,
    message,
    error,
    toastTrigger,
  } = useFilterHandler(url, filterData, setFilterData);

  const handleSearch = (startDate, endDate) => {
    setQueryParams({ startDate, endDate });
  };
  // useEffect(() => {
  //   dispatch(mmtc_redeemApi(queryParams));
  //   // dispatch(mmtc_sell_responseApi(queryParams));
  // }, [dispatch, queryParams]);

  useEffect(() => {
    apiCall(false);
  }, []);

  useEffect(() => {
    if (!message) return;

    console.log("Message updated:", message);

    if (error) {
      toast.error(message);
    }
    //  else {
    //   // toast.success(message);
    // }
  }, [toastTrigger]);

  const sliceResponse = useSelector(
    (state) => state.mmtc_redeem.mmtc_redeem.data,
  );
  const stateLoading = useSelector((state) => state.mmtc_redeem.loading);

  const columnHelper = createMRTColumnHelper();

  const columns = [
    // columnHelper.accessor("_id", {
    //   header: "ID",
    //   size: 30,
    //   Cell: ({ cell }) => {
    //     const handleCopy = () => {
    //       navigator.clipboard.writeText(cell.row.original?._id);
    //       toast.success("Copied to clipboard!");
    //     };
    //     return (
    //       <Tooltip title={cell.row.original?._id}>
    //         <IconButton onClick={handleCopy}>
    //           <ContentCopy />
    //         </IconButton>
    //       </Tooltip>
    //     );
    //   },
    // }),

    columnHelper.accessor("customerRefNo", {
      header: "Customer Ref No",
      size: 150,
      Cell: ({ cell }) => {
        const handleCopy = () => {
          navigator.clipboard.writeText(cell.row.original?.customerRefNo);
          toast.success("Copied to clipboard!");
        };
        return (
          <Tooltip title={cell.row.original?.customerRefNo}>
            <span>
              <IconButton onClick={handleCopy}>
                <ContentCopy />
              </IconButton>
              {cell.row.original?.customerRefNo}
            </span>
          </Tooltip>
        );
      },
    }),

    columnHelper.accessor("customerName", {
      header: "Name",
      size: 200,
    }),

    columnHelper.accessor("mobileNumber", {
      header: "Phone",
      size: 200,
    }),

    columnHelper.accessor("metalType", {
      header: "Metal Type",
      size: 200,
    }),

    columnHelper.accessor((row) => row.productList?.[0]?.weight || "-", {
      id: "weight",
      header: "Weight",
      size: 50,
    }),

    columnHelper.accessor((row) => row.productList?.[0]?.preTaxAmount, {
      id: "preTaxAmount",
      header: "Pre Tax Amount",
      size: 50,
    }),

    columnHelper.accessor("taxAmount", {
      header: "Total Tax Amount",
      size: 100,
    }),

    columnHelper.accessor("totalAmount", {
      header: "Total Amount",
      size: 100,
    }),

    // columnHelper.accessor("email", {
    //   header: "Email",
    //   size: 200,
    // }),
    // columnHelper.accessor("deliveryPartner", {
    //   header: "Delivery Partner",
    //   size: 200,
    // }),
    // columnHelper.accessor("trackingNumber", {
    //   header: "Tracking Number",
    //   size: 200,
    // }),
    columnHelper.accessor((row) => row.productList?.[0]?.productName, {
      id: "productName",
      header: "Product Name",
      size: 100,
    }),

    columnHelper.accessor((row) => row.productList?.[0]?.skuId || "-", {
      id: "skuId",
      header: "SkuId",
      size: 50,
    }),

    columnHelper.accessor("quoteId", {
      header: "Quote ID",
      size: 150,
      Cell: ({ cell }) => {
        const handleCopy = () => {
          navigator.clipboard.writeText(cell.row.original?.quoteId);
          toast.success("Copied to clipboard!");
        };
        return (
          <Tooltip title={cell.row.original?.quoteId}>
            <>
              <IconButton onClick={handleCopy}>
                <ContentCopy />
              </IconButton>
              {cell.row.original?.quoteId}
            </>
          </Tooltip>
        );
      },
    }),

    columnHelper.accessor("orderId", {
      header: "Order ID",
      size: 150,
      Cell: ({ cell }) => {
        const handleCopy = () => {
          navigator.clipboard.writeText(cell.row.original?.orderId);
          toast.success("Copied to clipboard!");
        };
        return (
          <Tooltip title={cell.row.original?.orderId}>
            <>
              <IconButton onClick={handleCopy}>
                <ContentCopy />
              </IconButton>
              {cell.row.original?.orderId}
            </>
          </Tooltip>
        );
      },
    }),

    columnHelper.accessor("pgOrderId", {
      header: "PG OrderId",
      size: 150,
      Cell: ({ cell }) => {
        const handleCopy = () => {
          navigator.clipboard.writeText(cell.row.original?.pgOrderId);
          toast.success("Copied to clipboard!");
        };
        return (
          <Tooltip title={cell.row.original?.pgOrderId}>
            <>
              <IconButton onClick={handleCopy}>
                <ContentCopy />
              </IconButton>
              {cell.row.original?.pgOrderId}
            </>
          </Tooltip>
        );
      },
    }),

    columnHelper.accessor("transactionId", {
      header: "Transaction ID",
      size: 150,
      Cell: ({ cell }) => {
        const handleCopy = () => {
          navigator.clipboard.writeText(cell.row.original?.transactionId);
          toast.success("Copied to clipboard!");
        };
        return (
          <Tooltip title={cell.row.original?.transactionId}>
            <>
              <IconButton onClick={handleCopy}>
                <ContentCopy />
              </IconButton>
              {cell.row.original?.transactionId}
            </>
          </Tooltip>
        );
      },
    }),

    columnHelper.accessor("invoiceId", {
      header: "Invoice ID",
      size: 150,
      Cell: ({ cell }) => {
        const handleCopy = () => {
          navigator.clipboard.writeText(cell.row.original?.invoiceId);
          toast.success("Copied to clipboard!");
        };
        return (
          <Tooltip title={cell.row.original?.invoiceId}>
            <>
              <IconButton onClick={handleCopy}>
                <ContentCopy />
              </IconButton>
              {cell.row.original?.invoiceId}
            </>
          </Tooltip>
        );
      },
    }),
    columnHelper.accessor("transactionRefNo", {
      header: "Transaction RefNo",
      size: 150,
      Cell: ({ cell }) => {
        const handleCopy = () => {
          navigator.clipboard.writeText(cell.row.original?.transactionRefNo);
          toast.success("Copied to clipboard!");
        };
        return (
          <Tooltip title={cell.row.original?.transactionRefNo}>
            <>
              <IconButton onClick={handleCopy}>
                <ContentCopy />
              </IconButton>
              {cell.row.original?.transactionRefNo}
            </>
          </Tooltip>
        );
      },
    }),

    // columnHelper.accessor("makingCharges", {
    //   header: "Making Charges",
    //   size: 100,
    // }),
    // columnHelper.accessor("pgOrderId", {
    //   header: "pg Order Id",
    //   size: 100,
    // }),
    columnHelper.accessor("partner_username", {
      header: "Partner Username",
      size: 100,
    }),

    columnHelper.accessor("partner_id", {
      header: "partner ID",
      size: 150,
      Cell: ({ cell }) => {
        const handleCopy = () => {
          navigator.clipboard.writeText(cell.row.original?.partner_id);
          toast.success("Copied to clipboard!");
        };
        return (
          <Tooltip title={cell.row.original?.partner_id}>
            <>
              <IconButton onClick={handleCopy}>
                <ContentCopy />
              </IconButton>
              {cell.row.original?.partner_id}
            </>
          </Tooltip>
        );
      },
    }),

    // columnHelper.accessor("goldQuantity", {
    //   header: "Gold Quantity",
    //   size: 150,
    //   Cell: (cell) => cell.row.original?.goldQuantity,
    // }),

    // columnHelper.accessor("goldMakingCharges", {
    //   header: "Gold Making Charge",
    //   size: 150,
    //   Cell: (cell) => cell.row.original?.goldMakingCharges,
    // }),
    // columnHelper.accessor("silverQuantity", {
    //   header: "Silver Quantity",
    //   size: 150,
    //   Cell: (cell) => cell.row.original?.silverQuantity,
    // }),

    // columnHelper.accessor("silverMakingCharges", {
    //   header: "Silver Making Charge",
    //   size: 150,
    //   Cell: (cell) => cell.row.original?.silverMakingCharges,
    // }),

    // columnHelper.accessor("billingAddressId", {
    //   header: "Billing Address ID",
    //   size: 150,
    //   Cell: (cell) => cell.row.original?.billingAddressId || "N/A",
    // }),
    // columnHelper.accessor("shippingAddressId", {
    //   header: "shipping Address ID",
    //   size: 150,
    //   Cell: (cell) => cell.row.original?.shippingAddressId || "N/A",
    // }),
    columnHelper.accessor((row) => row.productList?.[0]?.currencyPair || "-", {
      id: "currencyPair",
      header: "Currency Pair",
      size: 50,
    }),

    columnHelper.accessor("invoicePDF", {
      header: "Invoice",
      size: 100,
      Cell: ({ cell }) => {
        const url = cell.row.original?.invoicePDF;
        return url ? (
          <a
            href={url}
            target="_blank"
            rel="noopener noreferrer"
            style={{ color: "blue" }}
          >
            View
          </a>
        ) : (
          "N/A"
        );
      },
    }),

    // columnHelper.accessor("remainingBalance_1_balQuantity", {
    //   header: "Rem. Balance 1 Qty",
    //   size: 120,
    // }),

    // columnHelper.accessor("remainingBalance_1_currencyPair", {
    //   header: "Rem. Balance 1 Currency",
    //   size: 150,
    // }),

    // columnHelper.accessor("remainingBalance_1_blockedQuantity", {
    //   header: "Rem. Balance 1 Blocked",
    //   size: 120,
    // }),

    // columnHelper.accessor("remainingBalance_2_balQuantity", {
    //   header: "Rem. Balance 2 Qty",
    //   size: 120,
    // }),

    // columnHelper.accessor("remainingBalance_2_currencyPair", {
    //   header: "Rem. Balance 2 Currency",
    //   size: 150,
    // }),

    // columnHelper.accessor("remainingBalance_2_blockedQuantity", {
    //   header: "Rem. Balance 2 Blocked",
    //   size: 120,
    // }),
    columnHelper.accessor("completed", {
      header: "completed",
      size: 120,
      Cell: (cell) =>
        cell.row.original.completed ? (
          <span style={{ color: "green" }}>Yes</span>
        ) : (
          <span style={{ color: "red" }}>No</span>
        ),
    }),

    columnHelper.accessor("createdAt", {
      header: "Created At",
      size: 150,
      Cell: (cell) => cell.row.original?.createdAt?.split("T")[0],
    }),
    columnHelper.accessor("updatedAt", {
      header: "Updated At",
      size: 150,
      Cell: (cell) => cell.row.original?.updatedAt?.split("T")[0],
    }),
    // columnHelper.accessor("deliveryInDays", {
    //   header: "Delivery Date",
    //   size: 100,
    //   Cell: (cell) =>
    //     cell.row.original.deliveryInDays
    //       ? new Date(cell.row.original.deliveryInDays).toLocaleDateString()
    //       : "N/A",
    // }),
    columnHelper.accessor("Action", {
      header: "Action",
      size: 150,
      Cell: (cell) => (
        <Button
          onClick={() => {
            handleViewStatus(cell.row.original);
            setOpen(true);
          }}
          variant="contained"
        >
          View Status
        </Button>
      ),
    }),
  ];

  const baseUrl = import.meta.env.VITE_BASE_URL;
  const token = localStorage.getItem("token");

  const [selectedRow, setSelectedRow] = useState(null);
  // console.log("selectedRow: ", selectedRow);
  const handleViewStatus = async (row) => {
    try {
      const url = `/mmtc_redeem_info`;
      // const url = `${baseUrl}/mmtc_redeem_info`;
      const headers = {
        "Content-Type": "application/json",
        Accept: "application/json",
        Authorization: `Bearer ${token}`,
      };

      const response = await axiosInstance.post(
        url,
        {
          customerRefNo: row.customerRefNo,
          orderId: row.orderId,
        },
        // { headers }
      );
      // const response = await axios.post(
      //   url,
      //   {
      //     customerRefNo: row.customerRefNo,
      //     orderId: row.orderId,
      //   },
      //   { headers }
      // );
      setSelectedRow(response?.data?.data);
      console.log("response.data.data: ", response.data.data);
    } catch (error) {
      console.error("Error updating user:", error);
      Swal.fire({
        // text: response.data.message,
        text: "Something went wrong",
        icon: "error",
        timer: 3000,
        showConfirmButton: false,
      });
    }
  };
  const [open, setOpen] = useState(false);
  const handleClose = () => setOpen(false);

  //   const a=[
  //      {
  //        location: 'Greater Mumbai [Bombay]',
  //        status: 'Order Created',
  //        date: '10/11/2025'
  //      },
  //           { status: 'Order Dispatched', date: '10/11/2025' }
  // ,
  //      {
  //        location: 'MUMBAI, MUMBAI',
  //        partnerStatus: 'In Transit to',
  //        status: 'In Transit to',
  //        date: '2025-10-15T07:02:00.000Z'
  //      },
  //      {
  //        location: 'DELHI, DELHI',
  //        partnerStatus: 'Picked up and Booking processed ',
  //        status: 'Picked up and Booking processed ',
  //        date: '2025-10-15T05:00:00.000Z'
  //      },
  //      {
  //        location: 'DELHI, DELHI',
  //        partnerStatus: 'Shipment Picked',
  //        status: 'Shipment Picked',
  //        date: '2025-10-15T04:48:00.000Z'
  //      },
  //      {
  //        location: 'DELHI, DELHI',
  //        partnerStatus: 'Out for Pickup',
  //        status: 'Out for Pickup',
  //        date: '2025-10-14T17:04:00.000Z'
  //      },
  //      {
  //        location: 'DELHI, DELHI',
  //        partnerStatus: 'Shipment picked up and Available for Inscan',
  //        status: 'Shipment picked up and Available for Inscan',
  //        date: '2025-10-14T12:26:00.000Z'
  //      },
  //    ]

  let OrderTimeline = ({ a }) => {
    const statusColor = (status) => {
      const s = status.toLowerCase();

      switch (true) {
        case s.includes("order created"):
          return "success";
        case s.includes("in transit to"):
          return "warning";
        case s.includes("picked up and booking processed"):
          return "info";
        case s.includes("shipment picked"):
          return "primary";
        case s.includes("booking processed"):
          return "inherit";
        //  return "warning";
        case s.includes("available for inscan"):
          return "primary";
        case s.includes("out for pickup"):
          return "warning";
        case s.includes("shipment picked up and available for inscan"):
          return "secondary";
        case s.includes("order dispatched"):
          return "warning";
        case s.includes("delivered"):
          return "success";

        default:
          return "grey";
      }
    };

    // console.log(statusColor("Shipment picked up and Available for Inscan"));

    const toIST = (date) => {
      const d = new Date(date);
      return d.toLocaleString("en-IN", {
        timeZone: "Asia/Kolkata",
        hour12: true,
        day: "2-digit",
        month: "2-digit",
        year: "numeric",
        hour: "2-digit",
        minute: "2-digit",
      });
    };

    return (
      <Box sx={{ p: 0 }}>
        <Timeline position="alternate">
          {a?.map((item, index) => (
            <TimelineItem key={index}>
              {/* <TimelineOppositeContent
              sx={{ flex: 0.2 }}
              color="text.secondary"
            >
              {item.date}
            </TimelineOppositeContent> */}

              <TimelineSeparator>
                <TimelineDot color={statusColor(item.status)} />
                {index !== a.length - 1 && (
                  <TimelineConnector
                    sx={{ bgcolor: `${statusColor(item.status)}.main` }}
                  />
                )}
              </TimelineSeparator>

              <TimelineContent>
                <Typography variant="subtitle1" fontWeight="bold">
                  {item.status.charAt(0).toUpperCase() + item.status.slice(1)}
                </Typography>

                <Typography variant="body2">{item.location}</Typography>
                <Typography variant="body2">{toIST(item.date)}</Typography>
              </TimelineContent>
            </TimelineItem>
          ))}
        </Timeline>
      </Box>
    );
  };

  return (
    <>
      <Filter
        filterData={filterData}
        onFilterSubmit={handleFilterSubmit}
        Onclear={handleClearFilters}
        page={"mmtc_redeem"}
        setFilterData={setFilterData}
      />
      {/*  */}
      {/* <DateSearchComponent onSearch={handleSearch} /> */}
      {loader ? (
        <Loader />
      ) : (
        <Box mt={2}>
          <CustomTable
            columns={columns}
            data={results}
            loading={loader}
            permissionKey="MMTCRedeems"
          />
        </Box>
      )}

      <Dialog open={open} onClose={handleClose} maxWidth="lg" fullWidth>
        <DialogTitle>
          <strong style={{ fontSize: 18 }}>MMTC Redeem Details</strong>
          <Tooltip title="Close">
            <IconButton
              sx={{ float: "right" }}
              onClick={() => {
                handleClose(false);
              }}
              aria-label="delete"
              size="small"
            >
              <CloseIcon
                fontSize="inherit"
                color="error"
                sx={{ color: "red" }}
              />
            </IconButton>
          </Tooltip>
        </DialogTitle>
        <DialogContent dividers>
          {selectedRow ? (
            <Box sx={{ display: "flex", flexDirection: "column", gap: 2 }}>
              {/* Row 1 */}
              <Box
                sx={{
                  display: "flex",
                  justifyContent: "space-between",
                  gap: 2,
                }}
              >
                <Box sx={{ flex: 1 }}>
                  <Typography variant="body1">
                    <strong> Invoice ID:</strong> {selectedRow?.invoiceId}
                  </Typography>
                </Box>
                <Box sx={{ flex: 1 }}>
                  <Typography variant="body1">
                    <strong>deliveryPartner:</strong>{" "}
                    {selectedRow?.deliveryPartner}{" "}
                  </Typography>
                </Box>
                <Box sx={{ flex: 1 }}>
                  <Typography variant="body1">
                    <strong>trackingNumber:</strong>{" "}
                    {selectedRow?.trackingNumber}{" "}
                  </Typography>
                </Box>
                <Box sx={{ flex: 1 }}>
                  <Typography variant="body1">
                    <strong>finalResult:</strong> {selectedRow?.finalResult}
                  </Typography>
                </Box>
              </Box>

              <Typography
                variant="h6"
                sx={{
                  textAlign: "center",
                  fontWeight: "bold",
                  borderBottom: 0.1,
                  borderRadius: 1,
                }}
              >
                {/* Status */}
              </Typography>
              <Box sx={{ display: "flex", justifyContent: "space-around" }}>
                <Box>
                  <Typography
                    variant="h6"
                    sx={{
                      textAlign: "center",
                      fontWeight: "bold",
                      borderBottom: 0.5,
                      borderRadius: 1,
                    }}
                  >
                    Status
                  </Typography>
                  <OrderTimeline a={selectedRow?.statuses} />

                  {/* <OrderTimeline a={a} /> */}
                </Box>
                <Box>
                  <Typography
                    variant="h6"
                    sx={{
                      textAlign: "center",
                      fontWeight: "bold",
                      borderBottom: 0.5,
                      borderRadius: 1,
                    }}
                  >
                    Dashboard Status
                  </Typography>
                  <OrderTimeline a={selectedRow?.dashboardStatus} />
                </Box>
              </Box>
            </Box>
          ) : (
            <>
              <Box
                sx={{
                  display: "flex",
                  justifyContent: "center",
                  alignItems: "center",
                  height: "100vh",
                  backgroundColor: "background.default",
                }}
              >
                <CircularProgress size={80} sx={{ color: "#1976d2" }} />
              </Box>
            </>
          )}
        </DialogContent>
      </Dialog>
    </>
  );
}
